import { render, staticRenderFns } from "./DialogoDeMovimentacoes.vue?vue&type=template&id=b4e75060&scoped=true&"
import script from "./DialogoDeMovimentacoes.vue?vue&type=script&lang=ts&"
export * from "./DialogoDeMovimentacoes.vue?vue&type=script&lang=ts&"
import style0 from "./DialogoDeMovimentacoes.vue?vue&type=style&index=0&id=b4e75060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e75060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBottomSheet,VBtn,VCard,VCardText,VCardTitle,VCol,VDivider,VIcon,VRow,VSimpleTable,VSwitch})
